import { memo, FC, useState, useCallback, useMemo } from 'react';

import {
  MassMessageEntityWithRecipients,
  ConnectionTargetTypeCode,
} from 'models';

import { Collapse, Button } from '@material-ui/core';

import { CooperativeIcon, SpaceIcon } from 'components/icons';
import Recipient from '../recipient';
import ArrowDown from '@material-ui/icons/KeyboardArrowDown';

import clsx from 'clsx';
import { useStyles } from './style';

interface RecipientsEntityProps {
  entity: MassMessageEntityWithRecipients;
}

const RecipientsEntity: FC<RecipientsEntityProps> = ({ entity }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const hasChildren = !!entity.Recipients.length;

  const handleToggleExpanded = useCallback(() => {
    setExpanded((prevState) => !prevState);
  }, []);

  const RootIcon = useMemo(() => {
    return entity.Type === ConnectionTargetTypeCode.Cooperative
      ? CooperativeIcon
      : SpaceIcon;
  }, [entity.Type]);

  return (
    <div>
      <div
        className={clsx(classes.recepientsRow, {
          [classes.empty]: !!!hasChildren,
        })}
        onClick={hasChildren ? handleToggleExpanded : undefined}
      >
        <div className={classes.alignCenter}>
          <RootIcon className={classes.icon} />
          <span className={classes.label}>{entity.Name}</span>
        </div>
        {hasChildren && (
          <Button className={classes.btn}>
            <ArrowDown
              className={clsx(classes.arrowIcon, {
                [classes.activeArrowIcon]: expanded,
              })}
            />
          </Button>
        )}
      </div>
      <Collapse in={expanded} unmountOnExit>
        {entity.Recipients.map((recipient) => (
          <Recipient key={recipient.Id} recipient={recipient} />
        ))}
      </Collapse>
    </div>
  );
};

export default memo(RecipientsEntity);
